import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { Columns } from '@shared/interfaces/table/column-config';

export const meterFrameUnitTypePartial: Columns<any> = {
  title: 'meterFrame.unittype',
  key: 'unitType',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    chargingstation: 'meterFrame.unitTypeOptions.chargingstation',
    heatpump: 'meterFrame.unitTypeOptions.heatpump',
    batterysystem: 'meterFrame.unitTypeOptions.batterysystem',
    solarpowersystem: 'meterFrame.unitTypeOptions.solarpowersystem',
    windturbine: 'meterFrame.unitTypeOptions.windturbine',
    waterturbine: 'meterFrame.unitTypeOptions.waterturbine',
    gasturbine: 'meterFrame.unitTypeOptions.gasturbine',
    notspecified: 'enum.meteringpoint.unittype.notspecified',
  }
}
